const IF = require( "infrontjs" );

import { RegistrationState } from "../auth/RegistrationState";
import { LoginState } from "../auth/LoginState";
import { PaymentWallState } from "../index/PaymentWallState";

import './../../components/general/main-menu';
import './../../components/general/header-bar';

export class InAppState extends IF.State
{
    static ROUTE = null;
    static ID = null;

    canEnter()
    {
        if ( this.app.currentUser && true === this.app.currentUser.isPaying() )
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    getRedirectUrl()
    {
        if ( null === this.app.currentUser )
        {
            if ( true === this.app.storage.loadIsKnown() || true === this.app.storage.loadIsSoi() )
            {
                return LoginState.ROUTE;
            }
            else
            {
                return RegistrationState.ROUTE;
            }
        }
        else if ( false === this.app.currentUser.isPaying() )
        {
            return PaymentWallState.ROUTE;
        }
        else
        {
            throw new Error( 'Unhandled getRedirectUrl situation.' );
        }
    }
};
